// extracted by mini-css-extract-plugin
export default {"listItem":"A7E78IZY9nsclPSOPbr3"};